<template>
  <list ref="list" :state="2">
    <el-dropdown slot="column" slot-scope="{ data }">
      <el-link type="primary">{{ data.StateText }}<i class="el-icon-arrow-down" /></el-link>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-action="'/api/ProjectManage/Inquiry/SetDispatch'" @click.native="onDispatch(data)">指派投标人</el-dropdown-item>
        <el-dropdown-item v-action="'/api/ProjectManage/Inquiry/SetComplete'" :disabled="data.Bidder.Id != operator.Id" @click.native="onComplete(data)">设置投标结果</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </list>
</template>

<script>
import staffs from "@/views/company/branch/staff/_picker"
import complete from "./_complete.vue"
export default {
  components: { list: () => import("./_list.vue") },
  data () {
    return {
      operator: JSON.parse(localStorage.getItem("user"))
    }
  },
  methods: {
    //指派投标人
    onDispatch (row) {
      this.$layer.iframe({
        title: '选择人员',
        area: ['640px', '500px'],
        content: {
          content: staffs,
          parent: this,
          data: {
            callback: (res) => {
              this.$apis.project.inquiry.dispatch({
                id: row.Id,
                bidder: res.User.Id
              }).then(() => {
                row.Bidder = { Id: res.User.Id, Name: res.User.Name }
              }).catch(e => {
                this.$message.error(e || "执行错误")
              }).finally(() => {
                this.loading = false
              })
            }
          }
        }
      })
    },
    //投标
    onComplete (row) {
      this.$layer.iframe({
        title: '投标反馈',
        area: ['500px', 'auto'],
        content: {
          content: complete,
          parent: this,
          data: {
            row: {
              Id: row.Id,
              Price: row.BidPrice
            },
            callback: () => {
              this.$refs.list.resetForm()
            }
          }
        }
      })
    }
  }
}
</script>
